import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskChangeDeadlineUI = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskChangeDeadlineUI;
